let subThumbSwiper = null;
function createThumbButtons(container) {
    if (container.querySelector('.swiper-btn--thumb-up')) return;
    const wrapper = container.querySelector('.swiper-wrapper');
    if (!wrapper) return;

    const btnUp = document.createElement('div');
    btnUp.className = 'swiper-btn swiper-btn--thumb-up';
    btnUp.innerHTML = `
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10 15.8718L22 6L15.2 15.8718L22 26L10 15.8718Z" fill="currentColor"/>
        </svg>
    `;
    const btnDown = document.createElement('div');
    btnDown.className = 'swiper-btn swiper-btn--thumb-down';
    btnDown.innerHTML = `
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M22 16.1282L10 26L16.8 16.1282L10 6L22 16.1282Z" fill="currentColor"/>
        </svg>
    `;
    container.insertBefore(btnUp, wrapper);
    container.appendChild(btnDown);
}

function setThumbHeight() {
    const swiperEl = document.querySelector('.js-media-sublist');
    if (!swiperEl) return;
    if (window.matchMedia('(max-width: 989px)').matches) {
        swiperEl.style.height = '';
        return;
    }
    const slides = swiperEl.querySelectorAll('.swiper-slide');
    const GAP = 2;
    let heightSub = 0;
    const visibleSlides = Math.min(5, slides.length);
    for (let i = 0; i < visibleSlides; i++) {
        heightSub += slides[i].getBoundingClientRect().height;
    }
    heightSub += (visibleSlides - 1) * GAP;
    swiperEl.style.height = `${heightSub}px`;
}


function initSubThumbSwiper(isUpdate) {
    const el = document.querySelector('.js-media-sublist');
    if (!el) return;
    createThumbButtons(el);
    subThumbSwiper = new Swiper(el, {
        spaceBetween: 2,
        watchSlidesProgress: true,
        watchOverflow: true,
        resistance: false,
        freeMode: false,
        on: {
            init(swiper) {
                toggleThumbButtons(swiper);
                setThumbHeight();
                bindThumbButtons(swiper);
                if (!isUpdate) {
                    sliderInit(true);
                } else {
                    sliderInit(true);
                    subSliderInit(true);
                }
            },
            slideChangeTransitionEnd(swiper) {
                toggleThumbButtons(swiper);
            },
            slideChange: function () {
                window.pauseAllMedia();
                this.params.noSwiping = false;
            },
        },
        breakpoints: {
            0: { direction: 'horizontal', slidesPerView: 3 },
            990: { direction: 'vertical', slidesPerView: 5 },
        },
    });

    subThumbSwiper.on('touchEnd', function () {
        toggleThumbButtons(this);
    });
    subThumbSwiper.on('slideChange', function () {
        toggleThumbButtons(this);
    });
}

function bindThumbButtons(swiper) {
    if (!swiper || !swiper.el) return;
    const btnUp = swiper.el.querySelector('.swiper-btn--thumb-up');
    const btnDown = swiper.el.querySelector('.swiper-btn--thumb-down');
    if (!btnUp || !btnDown) return;

    const isMobile = () => swiper.currentBreakpoint === '0';

    btnUp.replaceWith(btnUp.cloneNode(true));
    btnDown.replaceWith(btnDown.cloneNode(true));

    const newBtnUp = swiper.el.querySelector('.swiper-btn--thumb-up');
    const newBtnDown = swiper.el.querySelector('.swiper-btn--thumb-down');

    newBtnUp.addEventListener('click', (e) => {
        e.preventDefault();
        if (swiper.isBeginning) return;
        const nextIndex = swiper.activeIndex - 1;
        isMobile() ? slideByIndex(swiper, nextIndex) : swiper.slideTo(nextIndex);
    });

    newBtnDown.addEventListener('click', (e) => {
        e.preventDefault();
        if (swiper.isEnd) return;
        const nextIndex = swiper.activeIndex + 1;
        isMobile() ? slideByIndex(swiper, nextIndex) : swiper.slideTo(nextIndex);
    });
}


function slideByIndex(swiper, nextIndex) {
    if (!swiper || swiper.destroyed) return;
    if (!swiper.slides[nextIndex]) return;
    swiper.updateSize();
    swiper.updateSlides();
    const translate = -swiper.slidesGrid[nextIndex];
    swiper.setTranslate(translate);
    swiper.activeIndex = nextIndex;
    swiper.updateSlidesClasses();
    toggleThumbButtons(swiper);
}


function toggleThumbButtons(swiper) {
    if (!swiper || !swiper.el) return;

    const btnUp = swiper.el.querySelector('.swiper-btn--thumb-up');
    const btnDown = swiper.el.querySelector('.swiper-btn--thumb-down');
    if (!btnUp || !btnDown) return;

    const isMobile = window.innerWidth < 990;

    if (isMobile) {
        const translate = swiper.getTranslate() || 0;
        const maxTranslate = swiper.maxTranslate() || 0;
        const minTranslate = swiper.minTranslate() || 0;

        btnUp.style.display = translate >= minTranslate ? 'none' : 'flex';
        btnDown.style.display = translate <= maxTranslate ? 'none' : 'flex';
    } else {
        btnUp.style.display = swiper.isBeginning ? 'none' : 'flex';
        btnDown.style.display = swiper.isEnd ? 'none' : 'flex';
    }
}



document.addEventListener('DOMContentLoaded', initSubThumbSwiper(false));
document.addEventListener("change", () => {
    const el = document.querySelector('.js-media-sublist');
    if (!el) return;
    el.classList.add('is-reinit');
    requestAnimationFrame(() => {
        initSubThumbSwiper(true)
        el.classList.remove('is-reinit');
    });
});
